<!-- 创建时间2023/06/16 15:00:46 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：内容标签 -->
<template>
  <div v-if="disabled">
    <yxt-tag v-for="item in tags" :key="item.id" type="info" size="small">
      {{ item.tagName }}
    </yxt-tag>
    <span v-if="tags.length === 0">--</span>
  </div>
  <yxtbiz-tag
    v-else
    v-model="tags"
    width="100%"
    class="v-mid kng-upload-tag d-in-block-im wp-100"
    required
    clearAfterAdded
    :module="101"
  />
</template>

<script>
export default {
  name: 'form-content-tag',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    tags: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  }
};
</script>